import { FC, useState } from 'react';
import './IngredientsTemplateHeader.scss';
import { IngredientsTemplateHeaderState } from './model';

const StandardComponent: FC<{ isMobile: boolean }> = ({ isMobile }) => {
	return (
		<div className='store-standars'>
			<div>
				{IngredientsTemplateHeaderState.storeStandarsText}
				<div className='template-onboarding-learn-more-container'></div>
			</div>
		</div>
	);
};
interface IIngredientsTemplateHeaderProps {
	isMobile: boolean;
}
export const IngredientsTemplateHeader: FC<IIngredientsTemplateHeaderProps> = ({ isMobile }) => {
	const [state] = useState({ ...IngredientsTemplateHeaderState });
	return (
		<div className='ingredients-template-header'>
			<div className='col'>
				<div className='row'>
					<div className='title-wrapper'>
						<span className='personalization-title'>{state.titleText}</span>
						{!isMobile && <span className='step'>{state.stepText}</span>}
					</div>
				</div>
				<div className='row'>
					<StandardComponent isMobile={isMobile} />
				</div>
			</div>
		</div>
	);
};
